var map = {
	"./alipay.svg": "c199",
	"./amex.svg": "e006",
	"./diners.svg": "bf93",
	"./discover.svg": "79b3",
	"./elo.svg": "1df5",
	"./hipercard.svg": "5322",
	"./jcb.svg": "8b75",
	"./maestro.svg": "b33f",
	"./mastercard.svg": "c241",
	"./paypal.svg": "c74a",
	"./unionpay.svg": "9beb",
	"./visa.svg": "844b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ada1";